import { InfoPanel, SvgComponent } from '@grays-npm/component-library';
import TagManager from 'react-gtm-module';
import {
  ListingModalTypeEnum,
  SetModalContentType,
} from '../../pages/Listings/Modals';
import { ListingStatusData } from './types';

export type ListingInfoPanelProps = {
  action: ListingStatusData;
  onViewPaymentDetails: SetModalContentType<ListingModalTypeEnum.ViewPaymentDetails>;
  titleIcon?: SvgComponent;
};

export const ListingInfoPanel = ({
  action,
  onViewPaymentDetails,
  titleIcon,
}: ListingInfoPanelProps) => {
  switch (action.linkActionType) {
    case 'view-payment-details':
      return (
        <InfoPanel
          {...action}
          titleIcon={titleIcon}
          onLinkClick={() => {
            action.linkActionData &&
              onViewPaymentDetails({
                type: ListingModalTypeEnum.ViewPaymentDetails,
                data: {
                  ...action.linkActionData,
                },
              });
            TagManager.dataLayer({
              dataLayer: {
                event: 'soldListings-sellerPaidDetails',
              },
            });
          }}
        >
          {action.message}
        </InfoPanel>
      );
    default:
      return (
        <InfoPanel {...action} titleIcon={titleIcon}>
          {action.message}
        </InfoPanel>
      );
  }
};
